import React from 'react';
import {
  Container,
  Title,
  Text,
  SimpleGrid,
  Card,
  Button,
  Stack,
  Center
} from '@mantine/core';
import { IconCloudDownload, IconCloudUpload, IconLayoutDashboard } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout';

const LandingPage = ({ onBackToPlatformSelector }) => {
  const navigate = useNavigate();

  const handleExportSelect = () => {
    navigate('/aws-credentials');
  };

  const handleImportSelect = () => {
    navigate('/aws-credentials?mode=import');
  };

  const handleSolutionStudioSelect = () => {
    navigate('/solution-studio');
  };

  return (
    <Layout onBackToPlatformSelector={onBackToPlatformSelector}>
      <Container size="lg" py="xl">
        <Stack align="center" gap="xl">
          <Stack align="center" gap="md">
            <Title order={1} size="h1" ta="center">
              AWS Connect Tools
            </Title>
            <Text size="xl" c="dimmed" ta="center" maw={600}>
              Export and import Amazon Connect resources with ease.
            </Text>
          </Stack>

          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} gap="lg" w="100%" maw={1000}>
            <Card
              shadow="md"
              padding="xl"
              radius="md"
              withBorder
              style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
              onClick={handleExportSelect}
              className="hover-card"
            >
              <Stack align="center" gap="md">
                <Center>
                  <IconCloudDownload size={48} color="#FF9900" />
                </Center>
                <Title order={3} ta="center">
                  Export Resources
                </Title>
                <Text size="sm" c="dimmed" ta="center">
                  Export Amazon Connect configuration, Lambda functions, and Lex bots from your AWS Account.
                </Text>
                <Button
                  variant="filled"
                  color="aws"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExportSelect();
                  }}
                >
                  Export from AWS
                </Button>
              </Stack>
            </Card>

            <Card
              shadow="md"
              padding="xl"
              radius="md"
              withBorder
              style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
              onClick={handleImportSelect}
              className="hover-card"
            >
              <Stack align="center" gap="md">
                <Center>
                  <IconCloudUpload size={48} color="#FF9900" />
                </Center>
                <Title order={3} ta="center">
                  Import Resources
                </Title>
                <Text size="sm" c="dimmed" ta="center">
                  Import Amazon Connect resources from an Excel file to a target Connect instance.
                </Text>
                <Button
                  variant="filled"
                  color="aws"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleImportSelect();
                  }}
                >
                  Import to AWS
                </Button>
              </Stack>
            </Card>

            <Card
              shadow="md"
              padding="xl"
              radius="md"
              withBorder
              style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
              onClick={handleSolutionStudioSelect}
              className="hover-card"
            >
              <Stack align="center" gap="md">
                <Center>
                  <IconLayoutDashboard size={48} color="#FF9900" />
                </Center>
                <Title order={3} ta="center">
                  Solution Studio
                </Title>
                <Text size="sm" c="dimmed" ta="center">
                  Design, build, and test Amazon Connect solutions — design docs, diagrams, CDK, and test artifacts.
                </Text>
                <Button
                  variant="filled"
                  color="aws"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSolutionStudioSelect();
                  }}
                >
                  Open Solution Studio
                </Button>
              </Stack>
            </Card>
          </SimpleGrid>
        </Stack>
      </Container>
    </Layout>
  );
};

export default LandingPage;